import { useParams } from 'react-router-dom'
import { ProgramWizard } from '../../components/program'

export function ProgramBuilderPage() {
  const { id } = useParams<{ id: string }>()

  const isEditing = !!id && id !== 'new'

  // Use the wizard for both create and edit modes
  return (
    <ProgramWizard
      editingProgramId={isEditing ? id : undefined}
    />
  )
}
